import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/home.vue"),
    meta: { template: "admin" },
  },
  {
    path: "/giris",
    name: "Login",
    component: () => import("../views/login.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/kayit",
    name: "Register",
    component: () => import("../views/register.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/forgot-password.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/hesabim/:id?",
    name: "MyAccount",
    component: () => import("../views/account/myAccount.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/odemelerim",
    name: "Receipts",
    component: () => import("../views/account/Receipts.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/siparislerim",
    name: "Orders",
    component: () => import("../views/account/Orders.vue"),
    meta: { template: "noside", requiresAuth: true },
  },
  {
    path: "/favorilerim",
    name: "Favorites",
    component: () => import("../views/account/Favorites.vue"),
    meta: { template: "noside", requiresAuth: true },
  },
  {
    path: "/kategori/:slug",
    name: "Category",
    component: () => import("../views/category.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/kategori/:categorySlug/:subcategorySlug",
    name: "Subcategory",
    component: () => import("../views/subcategory.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/koleksiyon/:slug",
    name: "Collection",
    component: () => import("../views/collection.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/urun/:slug",
    name: "ProductDetail",
    component: () => import("../views/ProductDetail.vue"),
    meta: { template: "noside" },
  },
  // {
  //   path: "/:slug?/:param?",
  //   name: "Page",
  //   component: () => import("../views/page.vue"),
  //   meta: { template: "noside" },
  // },
  {
    path: "/tum-urunler",
    name: "AllProducts",
    component: () => import("../views/TumUrunler.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/hakkimizda",
    name: "About",
    component: () => import("../views/about.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/iletisim",
    name: "Contact",
    component: () => import("../views/iletisim.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/sepet",
    name: "Cart",
    component: () => import("../views/cart.vue"),
    meta: { template: "noside", requiresAuth: true },
  },
  {
    path: "/odeme/:id?",
    redirect: "/siparis-olustur",
  },
  {
    path: "/siparis-olustur",
    name: "OrderWizard",
    component: () => import("../views/OrderWizard.vue"),
    meta: { template: "noside", requiresAuth: true },
  },
  {
    path: "/siparis-notu",
    name: "OrderNote",
    component: () => import("../views/OrderNote.vue"),
    meta: { template: "noside", requiresAuth: true },
  },
  {
    path: "/odeme-basarili",
    name: "PaymentSuccess",
    component: () => import("../views/payment/PaymentSuccess.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/siparis-tamamlandi",
    name: "SiparisTamamlandi",
    component: () => import("../views/payment/success.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/odeme-basarisiz",
    name: "PaymentFail",
    component: () => import("../views/payment/PaymentFail.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/kariyer",
    name: "Kariyer",
    component: () => import("../views/Kariyer.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("../views/Blog.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/magazalar",
    name: "Magazalar",
    component: () => import("../views/Magazalar.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/sss",
    name: "Sss",
    component: () => import("../views/Sss.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/teslimat",
    name: "Teslimat",
    component: () => import("../views/Teslimat.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/iade-degisim",
    name: "IadeDegisim",
    component: () => import("../views/IadeDegisim.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/siparis-takip",
    name: "SiparisTakip",
    component: () => import("../views/SiparisTakip.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/gizlilik",
    name: "Gizlilik",
    component: () => import("../views/Gizlilik.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/kvkk",
    name: "Kvkk",
    component: () => import("../views/Kvkk.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/acik-riza-metni",
    name: "AcikRizaMetni",
    component: () => import("../views/AcikRizaMetni.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/buket-olustur",
    name: "BouquetBuilder",
    component: () => import("../views/BouquetBuilder.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/logout.vue"),
    meta: { template: "noside" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/pageNotFound.vue"),
    meta: { template: "noside" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem("user")) {
    next({ path: "/giris", query: { uyari: "1", redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
